import axios from 'axios';

export default (query) => {
  const promise = new Promise((resolve, reject) => {
    let params = query || {};
    axios.get(process.env.VUE_APP_API_ADMIN_LOCATION + 'prescription-discounts', { params }).then(
      ({ data }) => {
        let prescriptionDiscounts = [];
        if (data.data) {
          prescriptionDiscounts.data = data.data;
          prescriptionDiscounts.pagination = data.pagination;
        }
        resolve(prescriptionDiscounts);
      },
      (error) => {
        reject(error);
      }
    );
  });

  return promise;
};
